import React from "react";
import "./Title.css";

type TitleProps = {
  name?: React.ReactNode;
  as?: React.ElementType;
  className?: string;
  children?: React.ReactNode;
};

const Title: React.FC<TitleProps> = ({
  name,
  as: Tag = "h1",
  className = "title lora",
  children,
}) => {
  const content = children ?? name;
  if (!content) return null;
  return React.createElement(Tag, { className }, content);
};

export default Title;
